// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import moment from 'moment'
// side effect
import 'moment-range'

const { FETCH_ORG_END_USER_COUNT_HISTORY_DONE } = require('constants/ActionConstants').default
import { toISOLocalDateString } from 'utils/DateHelpers'

const EndUserGrowthStore = Marty.createStore({
  id: 'EndUserGrowthStore',

  getInitialState() {
    return {
      endUserCountHistoryByDate: {}
    }
  },

  handlers: {
    fetchEndUserCountHistoryDone: FETCH_ORG_END_USER_COUNT_HISTORY_DONE
  },

  getEndUserCountHistory(startDate, endDate) {
    const histories = []
    const range = moment.range(startDate, endDate)
    range.by('days', day => {
      return histories.push(this.state.endUserCountHistoryByDate[day.format('YYYY-MM-DD')])
    })
    return histories
  },

  fetchEndUserCountHistory(startDate, endDate) {
    const id = `fetchEndUserCountHistory ${ toISOLocalDateString(startDate) }${ toISOLocalDateString(endDate) }`
    return this.fetch({
      id,
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.getEndUserCountHistory(startDate, endDate)
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.queries.EndUserQueries.fetchOrgEndUserCountHistory(orgId, startDate, endDate)
      }
    })
  },

  fetchEndUserCountHistoryDone(histories) {
    const endUserCountHistoryByDate = _.cloneDeep(this.state.endUserCountHistoryByDate)
    _.each(histories, history => endUserCountHistoryByDate[history.date] = history)
    return this.setState({ endUserCountHistoryByDate })
  }
})

export default EndUserGrowthStore



// WEBPACK FOOTER //
// ./src/scripts/stores/EndUserGrowthStore.js